import React, {Component} from 'react';
import FooterModal from "../../comum/components/FooterModal"
import { Label } from "reactstrap";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

export default class ModalAviso extends Component {
	render() {
		return (
            <div>
                <ModalContainer zIndex={100}>
                    <ModalDialog className="nosso-modal">
                        <div className={`modal-aviso ${this.props.className}`}>
                            {this.props.children}
                        </div>
                        <FooterModal>
                            <div className="justify-content-end">
                                <Label className="btn-primary" onClick={ this.props.onClickFechar }>FECHAR</Label>
                            </div>
                        </FooterModal>
                    </ModalDialog>
                </ModalContainer>
            </div>
        )
	}
}   



// WEBPACK FOOTER //
// ./src/modules/comum/components/ModalAviso.js